import { SHORTLIST_CONST } from '../actionConstants';
import {getFilteredData} from "../../UtilityComponents/cbTravelDeskUtil";

const INITIAL_STATE = {
	filterQuery:{},
	pageLoaded: false
}

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	}

	const { type, payload = {} } = action;

	switch (type) {
		case SHORTLIST_CONST.TRAVEL_REQUEST: {
			return {
				...state,
				...payload,
			}
		}
		case SHORTLIST_CONST.FILTER_RESULTS: {
			const {value, filter} = payload;
			const key = filter.key;
			const filterQuery = {...state.filterQuery};
			filterQuery[key] = value;

			const filterData = getFilteredData(state.wishlists, filterQuery,state.travelStatus,state.travelDeskFilters);

			return {
				...state,
				filterQuery: filterQuery,
				filterData: filterData
			}
		}
		case SHORTLIST_CONST.TRAVEL_REQUEST_CALLED: {
			return {
				...state,
				pageLoaded: true,
			}
		}

		default:
			return state;
	}
}
